import { useState } from 'react';

import { useMe } from '@crehana/auth';
import CrehanaLogo from '@crehana/icons/logos/Crehana';
import { MainMenu } from '@crehana/web';

import type { TCustomMainMenu } from '../types';

/**
 * @deprecated
 *
 * This is a legacy component used for organizations that are not centralized yet.
 */
const NewMainMenu = ({
  alternativeMainMenuProps,
}: {
  alternativeMainMenuProps: TCustomMainMenu;
}) => {
  const { me } = useMe();

  const [customLogoHasFailedToLoad, setCustomLogoHasFailedToLoad] =
    useState(false);

  const defaultLogJSX = (
    <a href="/ingresar/" className="tw-inline-block tw-mr-auto">
      <CrehanaLogo
        size={16}
        aria-hidden
        className="tw-text-primary-light-500"
      />
    </a>
  );

  const renderCustomLogo = () => {
    if (customLogoHasFailedToLoad) {
      return defaultLogJSX;
    }

    if (me?.organization?.logo) {
      return (
        <a href="/ingresar/" className="tw-inline-block tw-mr-auto tw-h-4">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            /**
             * Its important to handle image loading errors because legacy company (non-centralized) may have broken logo urls.
             * If it fails to load, we will render the default Crehana logo.
             */
            onError={() => setCustomLogoHasFailedToLoad(true)}
            src={me.organization.logo}
            alt={me.organization.name}
            className="tw-h-full tw-w-full tw-object-contain"
          />
        </a>
      );
    }

    return defaultLogJSX;
  };

  return (
    <nav className="tw-z-dialog tw-border-solid tw-border-b-[1px] tw-border-b-neutral-light-300 dark:tw-border-b-elevation-dark-04 tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-01">
      <MainMenu
        {...alternativeMainMenuProps}
        renderCustomLogo={renderCustomLogo}
      />
    </nav>
  );
};

export default NewMainMenu;
